export const aliases = {
  backgroundProps: ['bgColor'],
  borderProps: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderColor', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderStyle', 'borderTopColor', 'borderTopStyle', 'borderTopWidth', 'borderWidth'],
  borderRadiusProps: ['borderRadius'],
  colorProps: ['color'],
  flexProps: ['alignSelf', 'flex', 'flexBasis', 'flexGrow', 'flexShrink', 'order'],
  flexParentProps: ['alignContent', 'alignItems', 'flexDirection', 'flexWrap', 'justifyContent'],
  heightProps: ['height', 'maxHeight'],
  marginProps: ['m', 'mb', 'ml', 'mr', 'mt', 'mx', 'my'],
  paddingProps: ['p', 'pb', 'pl', 'pr', 'pt', 'px', 'py'],
  positioningProps: ['position', 'bottom', 'left', 'right', 'top', 'zIndex'],
  textProps: ['fontWeight', 'fontStyle', 'textAlign', 'fontFamily', 'decoration', 'textTransform'],
  widthProps: ['width', 'maxWidth'],
  floatProps: ['float'],
  displayProps: ['display']
};